var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "availabilities" },
    [
      _c("div", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column is-3" },
              [_c("app-sidebar"), _vm._v(" "), _c("onboarding")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column is-9" },
              [
                !_vm.currentOffice
                  ? _c("div", { staticClass: "section mt-7 mb-10" }, [
                      _c("p", { staticClass: "is-aligned-center" }, [
                        _vm._v(_vm._s(_vm.$t("no_office_selected")))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.offices, function(office) {
                  return _vm.currentOffice == office.id
                    ? _c("div", { key: office.id, staticClass: "mt-7" }, [
                        _c("div", { staticClass: "tabs" }, [
                          _c(
                            "ul",
                            _vm._l(_vm.dates, function(date) {
                              return _c(
                                "li",
                                {
                                  class: {
                                    "is-active": date == _vm.currentDate
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.selectDate(date)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("momentFormat")(
                                            date,
                                            "YYYY-MM-DD",
                                            _vm.$t("date_selector_format")
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column" }, [
                            _c(
                              "table",
                              { staticClass: "table is-striped is-fullwidth" },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [
                                      _vm._v(_vm._s(_vm.$t("morning_label")))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      { staticClass: "has-text-right" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("available_label"))
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    !_vm.showEarlySlots
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "has-text-centered clickable",
                                              attrs: { colspan: "2" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleEarlySlots()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "is-size-7",
                                                  attrs: { href: "#" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("show_early_slots")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm._.filter(_vm.timeSlots, function(
                                        time,
                                        key
                                      ) {
                                        return (
                                          key < 48 &&
                                          (_vm.showEarlySlots
                                            ? true
                                            : key >= 32 ||
                                              _vm._.has(
                                                _vm.officeReservedAvailabilities,
                                                key
                                              ))
                                        )
                                      }),
                                      function(slot) {
                                        return _c(
                                          "tr",
                                          {
                                            staticStyle: { overflow: "hidden" }
                                          },
                                          [
                                            _vm._.has(
                                              _vm.officeReservedAvailabilities,
                                              slot.key
                                            )
                                              ? _c("td", [
                                                  _vm.hasAvailabilityPictures(
                                                    slot.key
                                                  )
                                                    ? _c(
                                                        "figure",
                                                        {
                                                          staticClass:
                                                            "image thumbnail is-32x32 is-inline-block is-pulled-left m-1 mr-2 clickable",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.showEmergency(
                                                                slot.key
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticStyle: {
                                                              "max-height":
                                                                "100%",
                                                              "max-width":
                                                                "100%"
                                                            },
                                                            attrs: {
                                                              src: _vm.getAvailabilityPicture(
                                                                slot.key
                                                              ),
                                                              alt:
                                                                "Image Preview"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "button is-info is-outline is-pulled-left mr-2",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.showEmergency(
                                                                slot.key
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("b-icon", {
                                                            attrs: {
                                                              icon:
                                                                "clipboard-account"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "data-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                      " +
                                                          _vm._s(slot.start) +
                                                          " - " +
                                                          _vm._s(slot.end) +
                                                          "\n                                                      "
                                                      ),
                                                      _c("span", {
                                                        staticClass:
                                                          "is-size-7 has-text-grey has-text-weight-light",
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.getAvailabilityStatus(
                                                              slot.key
                                                            )
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "data-value",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.getPatientInfo(
                                                          slot.key
                                                        )
                                                      )
                                                    }
                                                  })
                                                ])
                                              : _c("td", [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "button is-info is-outline is-pulled-left mr-2",
                                                      attrs: { disabled: "" }
                                                    },
                                                    [
                                                      _c("b-icon", {
                                                        attrs: {
                                                          icon:
                                                            "clipboard-account"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "data-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(slot.start) +
                                                          " - " +
                                                          _vm._s(slot.end)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "data-value"
                                                    },
                                                    [_vm._v("—")]
                                                  )
                                                ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "has-text-right" },
                                              [
                                                !_vm.isPastSlot(slot)
                                                  ? _c("toggle-button", {
                                                      attrs: {
                                                        value: _vm.isTimeSlotActive(
                                                          slot.key
                                                        ),
                                                        disabled:
                                                          !_vm.doctor
                                                            .isCertified ||
                                                          _vm._.has(
                                                            _vm.officeReservedAvailabilities,
                                                            slot.key
                                                          ),
                                                        width: 40,
                                                        sync: true
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.toggle(
                                                            slot.key
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  ],
                                  2
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column" }, [
                            _c(
                              "table",
                              { staticClass: "table is-striped is-fullwidth" },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [
                                      _vm._v(_vm._s(_vm.$t("afternoon_label")))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      { staticClass: "has-text-right" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("available_label"))
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(
                                      _vm._.filter(_vm.timeSlots, function(
                                        time,
                                        key
                                      ) {
                                        return (
                                          key >= 48 &&
                                          (_vm.showLateSlots
                                            ? true
                                            : key < 80 ||
                                              _vm._.has(
                                                _vm.officeReservedAvailabilities,
                                                key
                                              ))
                                        )
                                      }),
                                      function(slot) {
                                        return _c("tr", [
                                          _vm._.has(
                                            _vm.officeReservedAvailabilities,
                                            slot.key
                                          )
                                            ? _c("td", [
                                                _vm.hasAvailabilityPictures(
                                                  slot.key
                                                )
                                                  ? _c(
                                                      "figure",
                                                      {
                                                        staticClass:
                                                          "image thumbnail is-32x32 is-inline-block is-pulled-left m-1 mr-2 clickable",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.showEmergency(
                                                              slot.key
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticStyle: {
                                                            "max-height":
                                                              "100%",
                                                            "max-width": "100%"
                                                          },
                                                          attrs: {
                                                            src: _vm.getAvailabilityPicture(
                                                              slot.key
                                                            ),
                                                            alt: "Image Preview"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button is-info is-outline is-pulled-left mr-2",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.showEmergency(
                                                              slot.key
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("b-icon", {
                                                          attrs: {
                                                            icon:
                                                              "clipboard-account"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-title" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                      " +
                                                        _vm._s(slot.start) +
                                                        " - " +
                                                        _vm._s(slot.end) +
                                                        "\n                                                      "
                                                    ),
                                                    _c("span", {
                                                      staticClass:
                                                        "is-size-7 has-text-grey has-text-weight-light",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getAvailabilityStatus(
                                                            slot.key
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "data-value",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.getPatientInfo(
                                                        slot.key
                                                      )
                                                    )
                                                  }
                                                })
                                              ])
                                            : _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button is-info is-outline is-pulled-left mr-2",
                                                    attrs: { disabled: "" }
                                                  },
                                                  [
                                                    _c("b-icon", {
                                                      attrs: {
                                                        icon:
                                                          "clipboard-account"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-title" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(slot.start) +
                                                        " - " +
                                                        _vm._s(slot.end)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-value" },
                                                  [_vm._v("—")]
                                                )
                                              ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "has-text-right" },
                                            [
                                              !_vm.isPastSlot(slot)
                                                ? _c("toggle-button", {
                                                    attrs: {
                                                      value: _vm.isTimeSlotActive(
                                                        slot.key
                                                      ),
                                                      disabled:
                                                        !_vm.doctor
                                                          .isCertified ||
                                                        _vm._.has(
                                                          _vm.officeReservedAvailabilities,
                                                          slot.key
                                                        ),
                                                      width: 40,
                                                      sync: true
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.toggle(
                                                          slot.key
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ])
                                      }
                                    ),
                                    _vm._v(" "),
                                    !_vm.showLateSlots
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "has-text-centered clickable",
                                              attrs: { colspan: "2" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleLateSlots()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "is-size-7",
                                                  attrs: { href: "#" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("show_late_slots")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                })
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      Object.keys(_vm.currentEmergency).length > 0
        ? _c("emergency-modal", {
            attrs: {
              active: _vm.showEmergencyModal,
              emergency: _vm.currentEmergency,
              availability: _vm.currentAvailability
            },
            on: {
              close: function($event) {
                return _vm.closeEmergencyModal()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-522d45c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-522d45c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/Availabilities.vue
// module id = 637
// module chunks = 1